export var AthleteDefaults = {
    name: null,
    validFor: null,
    idt: null,
    age: null,
    sex: null,
    medicalCheckupExpiration: null,
    rankingPoints: []
};
